module.exports = __webpack_public_path__ + "img/img0305.53d8cab4.png";